import React, { useEffect, useState } from "react";
import { LoginImage, Logo, MailIcon } from "../../common/imagePath";
import { Helmet } from "react-helmet";
import "./InvalidToken.css";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { useParams, useNavigate, Link } from "react-router-dom";
import config from "../../config/config";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import Loader from "../../components/Loader/Loader";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import Condition from "yup/lib/Condition";

function ResetPassword(props) {
  const [newPassword, setNewPassword] = useState("");
  const [newConfirmPassword, setNewConfirmPassword] = useState("");
  const paramObject = useParams();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [eye, seteye] = useState(true);
  const [eyeConfirm, setConfirmeye] = useState(true);
  const [conditionCheck, setConditionCheck] = useState();
  const [checkMessage, setCheckMessage] = useState();
  const [userID, setUserID] = useState();

  const onEyeClick = () => {
    seteye(!eye);
  };
  const onEyeConfirmClick = () => {
    setConfirmeye(!eyeConfirm);
  };

  // validation
  const schema = Yup.object().shape({
    newPassword: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters")
      .max(20, "Password must not exceed 20 characters"),
    confirmPassword: Yup.string()
      .required("Password is mandatory")
      .oneOf([Yup.ref("newPassword")], "Passwords does not match"),
  });

  let navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        `${config.authenticationBaseUrl}/users/resetpassword`,
        {
          id: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log("srers", res);
        if (
          res.data.ResponseCode === "SUCCESS" &&
          res.data.ResponseData[0].ID > 0
        ) {
          setConditionCheck(true);
          setCheckMessage(res.data.ResponseMessage);
          setUserID(res.data.ResponseData[0].ID);
          // toastSuccess(SUCCESS_MESSAGE);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseData[0].ID === -1
        ) {
          setCheckMessage(res.data.ResponseMessage);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseData[0].ID === -2
        ) {
          setCheckMessage(res.data.ResponseMessage);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error occured", error);
        setLoading(false);
      });
  }, []);

  const handleSubmit = async (e) => {
    console.log("e", e.newPassword);
    axios
      .post(
        `${config.authenticationBaseUrl}/users/updatepassword`,
        {
          password: e.newPassword,
          userid: userID,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log("update", res.data.ResponseCode);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess("Password Updated Successfully");
          navigate("/login");
        } else {
          toastError("Something went wrong!");
        }
      })
      .catch((error) => { });
  };

  return (
    <>

      <Loader loading={loading} />
      <div className="main-wrapper">
        <Helmet>
          <title>Reset Password - Sonar POS</title>
          <meta name="description" content="ForgetPassword page" />
        </Helmet>

        <div className="account-content">
          <div className="login-wrapper">
            <div className="login-content">
              <div className="login-userset ">
                {conditionCheck === true ? (
                  <Formik
                    initialValues={{ newPassword: "", confirmPassword: "" }}
                    validationSchema={schema}
                    onSubmit={handleSubmit}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                    }) => (
                      <Form>
                        <div className="login-logo">
                          <img src={Logo} alt="img" />
                        </div>
                        <div className="login-userheading">
                          <h3>Reset Password</h3>
                          <h4>
                            Please enter the New Password for your Account{" "}
                            <br />
                          </h4>
                        </div>

                        <div className="form-login">
                          <label>New Password</label>
                          <div className="pass-group">
                            {/* Password */}
                            <Field
                              type={eye ? "password" : "text"}
                              name="newPassword"
                              className={` ${errors.newPassword ? "is-invalid" : ""
                                }`}
                              placeholder="Enter your New password"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                            <span
                              onClick={onEyeClick}
                              className={`fas toggle-password ${eye ? "fa-eye-slash" : "fa-eye"
                                } `}
                            />
                            <div className="invalid-feedback">
                              {touched.newPassword && errors.newPassword
                                ? errors.newPassword
                                : ""}
                            </div>
                          </div>

                          {/* confirm password */}

                          <div className="mt-2">
                            <div className="pass-group ">
                              <label>Confirm Password</label>
                              <Field
                                type={eyeConfirm ? "password" : "text"}
                                name="confirmPassword"
                                className={` ${errors.confirmPassword ? "is-invalid" : ""
                                  }`}
                                placeholder="Confirm your New password"
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <span
                                onClick={onEyeConfirmClick}
                                className={`fas mt-3 toggle-password ${eyeConfirm ? "fa-eye-slash" : "fa-eye"
                                  } `}
                              />
                              <div className="invalid-feedback">
                                {touched.confirmPassword &&
                                  errors.confirmPassword
                                  ? errors.confirmPassword
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </div>

                        {errorMsg && (
                          <div className="form-login">
                            <span className="error">{errorMsg}</span>
                          </div>
                        )}
                        <div className="form-login">
                          <button type="submit" className="btn btn-login">
                            Submit
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <div className="invalid-token-container">
                    <h1>Something Went Wrong!</h1>
                    <p style={{ fontWeight: "bold", fontSize: "22px" }}>
                      {checkMessage}
                    </p>
                    <Link to="/login" style={{ fontSize: "20px" }}>
                      Back to Login
                    </Link>
                  </div>
                )}
              </div>
            </div>
            <div className="login-img">
              <img src={LoginImage} alt="img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
